export enum JournalEncounterFlags {
    AllianceOnly = 0x4,
    HordeOnly = 0x8,
}
